import {API_URL, THEME_COLOR} from "../constant"
import React, { useState } from 'react';
import HeaderBack from "../layout/HeaderBack";
import { useLocalStorage } from "../useLocalStorage";
// import { Link } from "react-router-dom";


const Register = ()=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    
    async function RegisterUser(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("firstname", document.getElementById("FirstName").value);
        urlencoded.append("lastname", document.getElementById("LastName").value);
        urlencoded.append("username", document.getElementById("Username").value);
        urlencoded.append("email", document.getElementById("Email").value);
        urlencoded.append("phone", document.getElementById("Phone").value);
        urlencoded.append("password", document.getElementById("Password").value);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/auth/register`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    async function CheckUsername(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("username", username);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/register/checkusername`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    async function CheckEmail(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("email", email);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/register/checkemail`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }
    async function CheckPhone(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("phone", phone);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/register/checkphone`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    async function FormValidation(){
        let valid = true;

        let fields = ["FirstName", "LastName", "Username", "Email", "Password", "ConfirmPassword"];
        let pswd = document.getElementById("Password").value;
        let cpswd = document.getElementById("ConfirmPassword").value;
        
        fields.map((value)=>{
            let field = document.getElementById(value);
            if(!field || field.value == ""){
                document.getElementById(value+"Validation").setAttribute("data-error", "This field is required");
                field.classList.remove("valid");
                field.classList.add("invalid");
            }else{
                field.classList.remove("invalid");
                field.classList.add("valid");
            }
        })

        if(document.getElementById("Username").value != ""){
            let response = await CheckUsername();
            response = JSON.parse(response)
            if(response.status == 200){
                document.getElementById("UsernameValidation").setAttribute("data-error", response.message);
                document.getElementById("Username").classList.remove("valid");
                document.getElementById("Username").classList.remove("invalid");
                document.getElementById("Username").classList.add(response.class);
            }else{
    
            }
        }

        if(document.getElementById("Email").value != ""){
            let response = await CheckEmail();
            response = JSON.parse(response)
            if(response.status == 200){
                document.getElementById("EmailValidation").setAttribute("data-error", response.message);
                document.getElementById("Email").classList.remove("valid");
                document.getElementById("Email").classList.remove("invalid");
                document.getElementById("Email").classList.add(response.class);
            }else{
    
            }
        }

        if(document.getElementById("Phone").value != ""){
            let response = await CheckPhone();
            response = JSON.parse(response)
            if(response.status == 200){
                document.getElementById("PhoneValidation").setAttribute("data-error", response.message);
                document.getElementById("Phone").classList.remove("valid");
                document.getElementById("Phone").classList.remove("invalid");
                document.getElementById("Phone").classList.add(response.class);
            }else{
    
            }
        }

        if(pswd != cpswd){
            document.getElementById("ConfirmPasswordValidation").setAttribute("data-error", "Password doesn't match");
            document.getElementById("ConfirmPassword").classList.remove("valid");
            document.getElementById("ConfirmPassword").classList.remove("invalid");
            document.getElementById("ConfirmPassword").classList.add("invalid");
        }else{
            
        }

        let countvalid = document.getElementsByClassName("invalid").length;
        valid = countvalid === 0;

        return valid;
    }

    async function SubmitHandler(event){
        event.preventDefault();
        let valid = await FormValidation();
        if(valid){
            let response = await RegisterUser();
            
            response = JSON.parse(response);
            if(response.status == 200){
                setToken(response.token);
                window.location = '/';
            }else{
                
            }
        }
    }

    return(
        <React.StrictMode>
            <HeaderBack title="Register" /> 
            <div className="row" style={{padding:"10px", backgroundColor:"white"}}>
                <form className="col s12">
                    <div className="row">
                        <div className="input-field col s6">
                            <input placeholder="First Name" id="FirstName" type="text" className="input-upper validate" required/>
                            <label className="active" htmlFor="FirstName" data-error="wrong">First Name</label>
                            <span className="helper-text" id="FirstNameValidation" data-error="this field is required" data-success=""></span>
                        </div>
                        <div className="input-field col s6">
                            <input placeholder="Last Name" id="LastName" type="text" className="input-upper validate" required />
                            <label className="active" htmlFor="LastName">Last Name</label>
                            <span className="helper-text" id="LastNameValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <input placeholder="Username" id="Username" type="text" className="validate" onChange={ e => setUsername(e.target.value)} />
                            <label className="active" htmlFor="Username">Username</label>
                            <span className="helper-text" id="UsernameValidation" data-error="insert an unique username" data-success=""></span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <input placeholder="Email" id="Email" type="email" className="validate" onChange={ e => setEmail(e.target.value)}/>
                            <label className="active" htmlFor="Email">Email</label>
                            <span className="helper-text" id="EmailValidation" data-error="incorrect email format" data-success=""></span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <input id="Phone" type="tel" placeholder="08XXXXX" pattern="08[0-9]{8,}" className="validate" onChange={ e => setPhone(e.target.value)} required/>
                            <label className="active" htmlFor="Phone">Phone Number</label>
                            <span className="helper-text" id="PhoneValidation" data-error="incorect format" data-success=""></span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <input placeholder="Password" id="Password" type="password" className="validate" />
                            <label className="active" htmlFor="Password" onChange={ e => setPassword(e.target.value)}>Password</label>
                            <span className="helper-text" id="PasswordValidation" data-error="" data-success=""></span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <input placeholder="Confirm Password" id="ConfirmPassword" type="password" className="validate" />
                            <label className="active" htmlFor="ConfirmPassword" onChange={ e => setConfirmPassword(e.target.value)}>Confirm Password</label>
                            <span className="helper-text" id="ConfirmPasswordValidation" data-error="" data-success=""></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col s12 center">
                            <a className={`btn ${THEME_COLOR}`} onClick={SubmitHandler}><i></i>Register</a>
                        </div>
                    </div>
                </form>
            </div>
        </React.StrictMode>
    );
}

export default Register;
